import { Button, Icon, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { FILTER_BY_GIFT_STATUS } from '@hero/constants';
import { Table } from '@hero/molecules';
import { getName } from '@hero/utils';

import { CustomSelectionHead } from '../../Contacts';
import { ShareLink } from '../ShareLink';

import * as S from './style';

function ShareTable({
  data = [],
  globalFilters,
  setPagination,
  setGlobalFilters,
  pagination,
  pageCount,
  isLoading,
  refetchRecognition
}) {
  const { t } = useTranslation();

  const columns = React.useMemo(
    () => [
      {
        header: t('email'),
        size: 320,
        cell: ({
          cell: {
            row: {
              original: {
                recipient: { email }
              }
            }
          }
        }) => <S.Email>{email}</S.Email>
      },
      {
        header: t('name'),
        size: 220,
        cell: ({
          cell: {
            row: {
              original: {
                recipient: { firstName, lastName }
              }
            }
          }
        }) => <S.Email>{getName({ firstName, lastName })}</S.Email>
      },
      {
        accessorKey: 'link',
        header: t('link'),
        cell: ({ row, cell: { getValue } }) => {
          return (
            <ShareLink
              secureSingleLink={getValue()?.shortened}
              name={row?.original?.status.accepted ? row.original.recipient.firstName : null}
            />
          );
        },
        size: 720
      }
    ],
    []
  );

  return (
    <S.ShareTable>
      <S.Header>
        <S.HeaderCol>
          <Typography variant="body2Bold">{t('recipients')}</Typography>
          <VerticalDivider $height={24} $margin="0 8px" />
          <Typography variant="body2">
            <Trans
              i18nKey="totalRecipients"
              values={{ count: data?.length || 0 }}
              components={{ b: <b /> }}
            />
          </Typography>
        </S.HeaderCol>
        <Button variant="link" startIcon={<Icon name="refresh" />} onClick={refetchRecognition}>
          {t('refresh')} ({data.length})
        </Button>
      </S.Header>
      <Table
        data={data}
        columns={columns}
        manualPagination
        globalFilters={globalFilters}
        setGlobalFilters={setGlobalFilters}
        setPagination={setPagination}
        pagination={pagination}
        loading={isLoading}
        rowHeight={52}
        pageCount={pageCount}
        enabled={{ filter: true, header: true }}
        filterOptions={FILTER_BY_GIFT_STATUS}
        filterProps={{
          placeholder: t('filterByType', { type: t('status') }),
          searchPlaceholder: t('searchTagOnFilterPlaceholder'),
          hideSearchOnMenu: true
        }}
        components={{
          SelectionHead: CustomSelectionHead
        }}
      />
    </S.ShareTable>
  );
}

export { ShareTable };
